import { UserRights } from '../user-rights.enum';
import { UserRole } from '../user-role.enum';

export class User {
  public fullName: string;

  public constructor(
    public token: string,
    public ppnUserId: string,
    public roles: UserRole[],
    public rights: UserRights[],
    public language: string,
    public org: number,
    public orgName: string,
  ) {}

  public setFullName(fullName: string): void {
    this.fullName = fullName;
  }
}
